import { useState, useEffect } from "react";
import { ConfirmedItemComponent } from "../../components/Coverages";
import { REPORT_TYPES } from "../../constants/TypeConstants";

export const EnrollmentBenefitComponent = (props: any) => {
  const { benefittitle, coverlettertitle, downloadbuttonlabel, nocarrier, nocarriermessage, coverletterfile, questionairetitle, questionairefile } = props;
  const eobFormButtonColor = "#f7f7f8";

  const [noCarrier, setNoCarrier] = useState(false);

  useEffect(() => {
    setNoCarrier(nocarrier);
  }, [nocarrier]);

  const questionaireButtonClicked = () => {
    window.open(questionairefile);
  };

  const inputData = [
    {
      eoiFormsType:false,
      isexists: coverletterfile ? true : false,
      title: coverlettertitle,
      buttontitle: downloadbuttonlabel,
      backcolor: eobFormButtonColor
    },
    {
      eoiFormsType:true,
      isexists: questionairefile ? true : false,
      title: questionairetitle,
      buttontitle: downloadbuttonlabel,
      navigateclicked: questionaireButtonClicked,
      backcolor: eobFormButtonColor
    }
  ];
    // Split by pipe (=)
  const paramValue = coverletterfile?.split('=')[1] || '-1';

  return (
    <div className="clearfix itemsection">
      <p className="mb-3">{benefittitle}</p>
      {inputData && 
      <ConfirmedItemComponent finishEnrollmentData={inputData}  reportType={REPORT_TYPES.EOI_FORM} paramValue={paramValue} />}
      {noCarrier && <p className="m-0">{nocarriermessage}</p>}
    </div>
  );
};

export default EnrollmentBenefitComponent;
